import { Modal } from '~/components';
import { Form } from 'semantic-ui-react';
import { FormRadioSelectGroup } from '~/components/form';
import { CreateProjectDealTypeRadioOptions } from '~/constants/create-project';
import { Button } from '~/components';
import { useForm } from '~/hooks';

interface CreateNewProjectDealTypeProps {
  closeModal: () => void;
  onSubmit: () => void;
}

const CreateNewProjectDealType = ({
  closeModal,
  onSubmit
}: CreateNewProjectDealTypeProps) => {
  const { formState } = useForm() as any;

  return (
    <>
      <Modal.Title>
        Create new project
      </Modal.Title>
      <Modal.Content>
        <Form>
          <FormRadioSelectGroup
            schemaKey="createProjectDealTypeSelection"
            fieldLabel="What type of energy project are you planning?"
            values={CreateProjectDealTypeRadioOptions}
            inline
            stretched
          />  
        </Form>
      </Modal.Content>
      <Modal.Footer>
        <Button 
          primary 
          outlined 
          onClick={() => closeModal()}
        >
          Cancel
        </Button>
        <Button 
          primary
          disabled={!formState.createProjectDealTypeSelection} 
          onClick={onSubmit} 
        >
          Continue
        </Button>
      </Modal.Footer>
    </>
  );
};

export default CreateNewProjectDealType;